import CreateQuoteForm from "@components/CreateQuoteForm/CreateQuoteForm";
import React from "react";
import { useTranslation } from "react-i18next";
import "./index.scss";

const CreateQuotePage = () => {
  const { t } = useTranslation();

  return (
    <div className="invoice-layout d-flex" id="invoice-list-page">
      <div className="invoice-create-container">
        <div className="invoice-create-header">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}>
            <h1 className="p-2">{t("quote.new_quote") || "Nouveau devis"}</h1>
          </div>
        </div>
        <CreateQuoteForm />
      </div>
    </div>
  );
};

export default CreateQuotePage;
